import * as React from "react";
import ProductRepository from "client-sdk/src/Repository/product-repository";
import CategoriesSection from "../components/categories";
import LatestProducts from "../components/latest";
import Headers from "../components/header";
import MostOrdered from "../components/mostOrdered";
// import MostOrdered from "../../components/mostOrdered";


const Categories = (props: any) => {
  const [categories, setCategories] = React.useState([])
  const [latestProduct, setLatestProduct] = React.useState([])
  const [orderedProduct, setorderedProduct] = React.useState([])

  React.useEffect(() => {
    getCategory()
    getLatestProduct()
    getOrderedProduct()
  }, [])

  const getCategory = async () => {
    const category = await ProductRepository.getVitrinCategories({});
    setCategories(category?.data)
  }

  const getLatestProduct = async () => {
    const products = await ProductRepository.getVitrinProducts({ payload: { sort: "created,desc", size: 4 } });
    setLatestProduct(products?.data)
  }
  const getOrderedProduct = async () => {
    const products = await ProductRepository.getVitrinProducts({ payload: { sort: "price,desc", size: 4 } });
    setorderedProduct(products?.data)
  }

  return (
    <>
      <Headers />
      <div className="vitrin-container bg-white pb-5">
        <div className="banner">
          <img className="banner-img" src="/vitrin/images/banner.png" alt="banner" />
        </div>
        <CategoriesSection categories={categories} />
        <div className="wrapper-lg mt-2">
          <div className="banner">
            <img className="banner-img" src="/vitrin/images/banner2.png" alt="banner" />
          </div>
        </div>
        <LatestProducts products={latestProduct} />
        <hr className="mt-5 mb-5 hr" />
        <MostOrdered products={orderedProduct} />
      </div>
    </>
  )
}

export default Categories;